import { BaseContext } from '../../../utils/basecontext';
import * as moment from 'moment';

export class DateFormat
{
    static formatExpiryDate(dateTime: string, context: BaseContext): string
    {
        try 
        {
            return (dateTime !== null && dateTime !== undefined) ? moment(dateTime).format('DD/MM/YYYY') : 
            DateFormat.formatExpiryDate(context.getConfigurationSettings()
            .getPropertyBasedOnLanguage("DEFAULT_TONE_EXPIRY_DATE"), context);
            // context.getResources().getString(Strings.zero_date);
        }
        catch(e)
        {
            return DateFormat.formatExpiryDate(context.getConfigurationSettings()
            .getPropertyBasedOnLanguage("DEFAULT_TONE_EXPIRY_DATE"), context);
            // return context.getResources().getString(Strings.zero_date);
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dateformat/dateformat.ts